import React from 'react'
import { Box } from '@mui/material'
import { useTranslation } from '../shared/hooks/useIntractionTranslate'
import { INTERAX_COLORS } from '../constants/colors'

export const LiveStatusPill: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        px: 1.5,
        py: 0.5,
        borderRadius: '9999px',
        backgroundColor: INTERAX_COLORS.greenBackground
      }}
    >
      <Box
        sx={{
          width: '8px',
          height: '8px',
          borderRadius: '50%',
          backgroundColor: INTERAX_COLORS.green
        }}
      />
      <Box
        sx={{
          fontSize: '0.875rem',
          fontWeight: '500',
          color: INTERAX_COLORS.green
        }}
      >
        {t('common.live')}
      </Box>
    </Box>
  )
}

export default LiveStatusPill
